import React from "react";
import { Container, Typography, Link, Box } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";

const Contacts = () => {
	return (
		<Container disableGutters sx={{ marginTop: 4, marginBottom: 4 }}>
			<Box
				sx={{
					display: "flex",
					flexDirection: { xs: "column", md: "row" },
					gap: 4
				}}
			>
				<Box sx={{ flex: 1 }}>
					<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
						<Typography variant="h6" gutterBottom>
							LINKS
						</Typography>
						<ArrowForward
							sx={{ transform: "rotate(45deg)", fontSize: "small" }}
						/>
					</Box>
					<Box>
						<Link href="/" color="inherit" underline="hover">
							<Typography
								variant="h5"
								component="span"
								sx={{ textDecoration: "underline" }}
							>
								Home
							</Typography>
						</Link>
					</Box>
					<Box>
						<Link href="/blog" color="inherit" underline="hover">
							<Typography
								variant="h5"
								component="span"
								sx={{ textDecoration: "underline" }}
							>
								Blog
							</Typography>
						</Link>
					</Box>
				</Box>
				<Box sx={{ flex: 1 }}>
					<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
						<Typography variant="h6" gutterBottom>
							SOCIALS
						</Typography>
						<ArrowForward
							sx={{ transform: "rotate(45deg)", fontSize: "small" }}
						/>
					</Box>
					<Box>
						<Link
							href="https://github.com/Morilili"
							color="inherit"
							underline="hover"
							target="_blank"
							rel="noopener"
						>
							<Typography
								variant="h5"
								component="span"
								sx={{ textDecoration: "underline" }}
							>
								GitHub
							</Typography>
						</Link>
					</Box>
					<Box>
						<Link
							href="https://www.linkedin.com/in/morrisho7/"
							color="inherit"
							underline="hover"
							target="_blank"
							rel="noopener"
						>
							<Typography
								variant="h5"
								component="span"
								sx={{ textDecoration: "underline" }}
							>
								LinkedIn
							</Typography>
						</Link>
					</Box>
					<Box>
						<Link
							href="https://www.youtube.com/@morrisho5613"
							color="inherit"
							underline="hover"
							target="_blank"
							rel="noopener"
						>
							<Typography
								variant="h5"
								component="span"
								sx={{ textDecoration: "underline" }}
							>
								YouTube
							</Typography>
						</Link>
					</Box>
					<Box>
						<Link
							href="https://www.instagram.com/mo.rris/"
							color="inherit"
							underline="hover"
							target="_blank"
							rel="noopener"
						>
							<Typography
								variant="h5"
								component="span"
								sx={{ textDecoration: "underline" }}
							>
								Instagram
							</Typography>
						</Link>
					</Box>
				</Box>
			</Box>
			<Box sx={{ textAlign: "left", marginTop: 4 }}>
				<Typography variant="body2" color="text.secondary">
					&copy; {new Date().getFullYear()} Morris Ho. All rights reserved.
				</Typography>
			</Box>
		</Container>
	);
};

export default Contacts;
